var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0482 10.627C18.7668 10.627 19.3597 10.0386 19.2531 9.3249C18.6907 5.55627 15.7242 2.57734 11.9714 2.01249C11.2607 1.90552 10.6747 2.50084 10.6747 3.2225V9.75591C10.6747 10.237 11.0631 10.627 11.5422 10.627H18.0482Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0761 15.0245C16.3335 14.4623 16.5229 13.8621 16.6336 13.2347C16.759 12.5241 16.1644 11.9341 15.4458 11.9341H10.6747C9.95606 11.9341 9.37349 11.3491 9.37349 10.6275V5.83629C9.37349 5.11463 8.78602 4.51755 8.07841 4.64345C4.62371 5.25812 2 8.28844 2 11.9341C2 16.0235 5.30123 19.3387 9.37349 19.3387C11.8128 19.3387 13.9755 18.1491 15.3177 16.3162L20.7659 21.7874C21.0483 22.0709 21.506 22.0709 21.7883 21.7874C22.0706 21.5039 22.0706 21.0442 21.7883 20.7608L16.0761 15.0245Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.90e8f410c3c1ea61cea0d8bd741eef67.svg";
export { ForwardRef as ReactComponent };